import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const LanguageHeader = styled.h5`
  margin-top: 0px;
  margin-bottom: 0px;
`;

export const ImplVersionContainer = styled.div`
  margin-top: 5px;
  padding-top: 5px;
  border-top: 1px solid ${colors.borderGray};
`;

export const VersionStatus = styled.span`
  ${({ color }) =>
    color &&
    css`
      color: ${color} !important;
    `}
`;
